import styled from 'styled-components'

export const DateContainer = styled.div`
    right: 0;
    top: 0;
    position: absolute;
    padding: 0 1rem;
`